import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import DialogTitle from '../../components/common/Dialog/DialogTitle';
import ClientService from '../../services/client.service';

interface DeleteClientDialogProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  clientId: string;
}

const DeleteClientDialog: React.FC<DeleteClientDialogProps> = ({
  open,
  onClose,
  onSuccess,
  clientId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleDelete = useCallback(async () => {
    const { message, error } = await ClientService.deleteClient(clientId);
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    } else if (message) {
      enqueueSnackbar(message, { variant: 'success' });
      onSuccess?.();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        className: 'w-4/12',
      }}
    >
      <DialogTitle title="Delete Brand" onClose={onClose} />
      <DialogContent>
        <Typography>
          Are you user you want to delete the Brand? The changes can't be reverted back!!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button color="secondary" onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteClientDialog;
